import React from 'react';
import { Box, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { ResponsiveTableGrid } from 'components';
import useRouterUtils from 'utils/router/routerUtilsHook';
import useService from 'utils/services';
import DeletePlaceDialog from 'components/TableGrid/DeletePlaceDialog';

export default function ProvincesIndex() {
  const { province, region } = useService();
  const { redirect } = useRouterUtils();

  const fetchData = async () => {
    let provincesData = await province.fetchProvinces();
    const regionsData = await region.fetchRegions();
    const regions = {};
    regionsData.forEach((regionObj) => {
      regions[regionObj.id] = regionObj.name;
    });
    provincesData = provincesData.map((provinceObj) => {
      return {
        ...provinceObj,
        regionName: regions[provinceObj.region_id],
      };
    });

    return provincesData;
  };

  const headers = [
    {
      field: 'name',
      headerName: 'Nombre',
      flex: 1,
    },
    {
      field: 'regionName',
      headerName: 'Región',
      flex: 1,
    },
  ];

  return (
    <>
      <div className="ProvincesIndex">
        <h2 className="title"> Provincias </h2>
        <Box align="center">
          <Button
            component={Link}
            to="/provincias/nueva"
            className="new-entity-btn"
            variant="contained"
          >
            Nueva provincia
          </Button>
        </Box>
        <ResponsiveTableGrid
          fetchAllFunc={fetchData}
          headers={headers}
          tableName="provinces"
          canEdit
          canDelete
          deleteEntityName={(row) => ` la provincia ${row.name}`}
          onEdit={(row) => redirect(`/provincias/editar/${row.id}`)}
          DeleteDialog={DeletePlaceDialog}
        />
      </div>
    </>
  );
}
